import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Scrollmagic
// import Scrollmagic from 'scrollmagic'
import VueScrollmagic from 'vue-scrollmagic'

// Bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

// require jquery
// import $ from 'jquery'

// Vue Scroll
import VueScrollTo from 'vue-scrollto'
// Vue.use(VueScrollmagic)

Vue.use(VueScrollTo, {
  offset: 0
})

Vue.use(VueScrollmagic, {
  // vertical: true,
  // globalSceneOptions: {
  //   duration: '200%'
  // },
  // loglevel: 2,
  // refreshInterval: 100
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
